<template>
  <section class="page-section" v-loading="pageLoading">
    <!-- 步骤条 -->
    <div class="steps-bar flex-h">
      <div
        :class="[
          step == 1 ? 'steps-item flex-a-i active' : 'steps-item flex-a-i',
        ]"
      >
        step1：编辑基本信息
      </div>
      <div
        :class="[
          step == 2 ? 'steps-item flex-a-i active' : 'steps-item flex-a-i',
        ]"
      >
        step2：编辑商品详情
      </div>
    </div>
    <!-- step 1 -->
    <div class="step-content" v-show="step == 1">
      <el-form
        size="small"
        ref="formData"
        :model="formData"
        label-width="150px"
        class="content-form"
      >
        <!-- 商品类型 -->
        <div class="form-module">
          <div class="module-header">商品类型</div>
          <div class="module-body select-type">
            <div class="type-wrap">
              <div
                class="type-item"
                :class="{ active: formData.baseInfo.abroadType == '1' }"
                @click="handleBaseInfoChange('abroadType', '1')"
              >
                <p class="label">大贸商品</p>
                <p class="tips">国内仓</p>
              </div>
              <div
                class="type-item"
                :class="{ active: formData.baseInfo.abroadType == '2' }"
                @click="handleBaseInfoChange('abroadType', '2')"
              >
                <p class="label">跨境商品</p>
                <p class="tips">保税仓</p>
              </div>
            </div>
            <div class="type-wrap link">
              <div
                class="type-item"
                :class="{ active: formData.baseInfo.commodityType == '1' }"
                @click="handleBaseInfoChange('commodityType', '1')"
              >
                <p class="label">普通商品</p>
                <p class="tips">正常显示</p>
              </div>
              <div
                class="type-item"
                :class="{ active: formData.baseInfo.commodityType == '2' }"
                @click="handleBaseInfoChange('commodityType', '2')"
              >
                <p class="label">专链商品</p>
                <p class="tips">不显示</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 基本信息 -->
        <div class="form-module">
          <div class="module-header">基本信息</div>
          <div class="module-body">
            <el-form-item label="排序号" required :show-message="false">
              <el-input
                v-model="formData.baseInfo.sort"
                class="w150"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item label="产地" required :show-message="false">
              <el-select
                v-model="formData.baseInfo.regionId"
                :loading="regionOptionsLoading"
                placeholder=""
                class="w150"
              >
                <el-option
                  v-for="item in regionOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="'' + item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="进口税税率" required :show-message="false">
              <el-select
                v-model="formData.baseInfo.rateId"
                :loading="rateOptionsLoading"
                placeholder=""
                class="w150"
              >
                <el-option
                  v-for="item in rateOptions"
                  :key="item.id"
                  :label="item.rateLabel"
                  :value="'' + item.id"
                ></el-option>
              </el-select>
              <el-checkbox
                v-model="formData.baseInfo.includeTax"
                true-label="1"
                false-label="0"
                class="margin-left-5"
                >价格已含税</el-checkbox
              >
            </el-form-item>
            <el-form-item label="发货仓库" required :show-message="false">
              <el-select
                v-model="formData.baseInfo.warehouseId"
                :loading="warehouseOptionsLoading"
                placeholder=""
                class="w300"
              >
                <el-option
                  v-for="item in warehouseOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="'' + item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="商品货号" required :show-message="false">
              <el-input
                v-model="formData.baseInfo.code"
                class="w150"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item label="商品名称" required :show-message="false">
              <el-input
                v-model="formData.baseInfo.name"
                class="w400"
                maxlength="100"
                placeholder="中/英文字符、符号，不超过100个中文字符"
                @blur="handleValidGoodsName"
              ></el-input>
            </el-form-item>
            <div
              class="delete-block w465 delete-block-category"
              v-for="(cateItem, cateIndex) in formData.baseInfo.categoryList"
              :key="cateIndex"
            >
              <div
                class="icon-delete"
                @click="handleCategoryDelete(cateIndex)"
                v-if="formData.baseInfo.categoryList.length > 1"
              ></div>
              <el-form-item label="一级分类" required :show-message="false">
                <el-select
                  filterable
                  v-model="cateItem.firstCategoryId"
                  placeholder=""
                  class="w150"
                  @change="handleFirstCategoryChange(cateIndex, 'user')"
                >
                  <el-option
                    v-for="item in firstCategoryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="'' + item.id"
                  ></el-option>
                </el-select>
                <el-button
                  type="text"
                  @click="getFirstCategoryList(true)"
                  :loading="firstCategoryOptionsLoading"
                  >刷新</el-button
                >
                <router-link
                  class="router-link-active"
                  :to="{ path: '/shop/component/list', query: { name: 2 } }"
                  >新建类目</router-link
                >
              </el-form-item>
              <el-form-item label="二级分类" required :show-message="false">
                <el-select
                  filterable
                  v-model="cateItem.secondCategoryId"
                  placeholder=""
                  class="w150"
                  @change="handleSecondCategoryChange(cateIndex, 'user')"
                >
                  <el-option
                    v-for="item in cateItem.secondCategoryOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="'' + item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="类目标签" required :show-message="false">
                    <el-select filterable v-model="cateItem.categoryLabelId" placeholder="" class="w150">
                      <el-option v-for="item in cateItem.categoryLabelOptions" :key="item.id" :label="item.name"
                        :value="'' + item.id"></el-option>
                    </el-select>
                  </el-form-item> -->
            </div>
            <!-- <el-form-item label="">
                  <el-button size="small" type="default" plain @click="handleCategoryAdd">添加类目</el-button>
                </el-form-item> -->
            <!-- <el-form-item label="卖点">
                  <el-input v-model="formData.baseInfo.sellingPoint" class="w400" maxlength="60"
                    placeholder="中/英文字符、符号，不超过60个中文字符"></el-input>
                </el-form-item> -->
            <!-- <el-form-item label="主图视频" :show-message="false">
                  <div class="pics-box">
                    <template v-if="uploadVideoList.length === 0">
                      <el-upload :action="uploadPicUrl" list-type="picture-card" :file-list="uploadVideoList"
                        accept=".mp4,.mov" drag :on-preview="handleVideosPreview" :on-remove="handleVideosRemove"
                        :on-success="handleVideosSuccess" :on-error="handleVideosError"
                        :before-upload="handleVideosBeforeUpload" :on-exceed="handleVideosExceed" :limit="videosLimit">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </template>
<template v-else>
                      <div class="video-box">
                        <template v-for="(row, rowIndex) in uploadVideoList">
                          <div class="video-item" :key="rowIndex">
                            <video :src="row.response.data.path" class="video"></video>
                            <div class="mask">
                              <i class="el-icon-zoom-in" @click.stop="handleVideosPreview"></i>
                              <i class="el-icon-delete" @click.stop="handleVideosRemove"></i>
                            </div>
                          </div>
                        </template>
</template>
</div>
<p class="tips">支持MP4、MOV格式，分辨率不低于720P，时长不超过30秒，大小不超过500MB。</p>
<p class="tips">视频高宽比为1：1，建议尺寸：800*800像素，最多上传1个。</p>
</el-form-item> -->
            <el-form-item label="商品图" required :show-message="false">
              <div class="pics-box pics-box-goods">
                <el-upload
                  :action="uploadPicUrl"
                  list-type="picture-card"
                  :file-list="uploadPicList"
                  accept=".png,.jpg,.jpeg"
                  drag
                  :on-preview="handlePicturesPreview"
                  :on-remove="handlePicturesRemove"
                  :on-success="handlePicturesSuccess"
                  :on-error="handlePicturesError"
                  :before-upload="handlePicturesBeforeUpload"
                  :on-exceed="handlePicturesExceed"
                  :limit="picsLimit"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
              <p class="tips">
                建议尺寸：800*800像素，可以拖拽图片调整顺序，最多上传6张
              </p>
            </el-form-item>
            <el-form-item label="标签">
              <span
                class="input-delete-wrap"
                v-for="(item, index) in formData.baseInfo.tags"
                :key="index"
              >
                <el-input
                  v-model="item.label"
                  class="w120"
                  maxlength="8"
                  placeholder="2-8个中文字符"
                ></el-input>
                <div class="btn-delete" @click="handleTagsDelete(index)"></div>
              </span>
              <el-button
                type="text"
                size="small"
                @click="handleTagsAdd()"
                v-if="formData.baseInfo.tags.length < 4"
                >添加标签</el-button
              >
            </el-form-item>
            <el-form-item label="商品规格" required :show-message="false">
              <div
                class="delete-block w465"
                v-for="(item, index) in formData.baseInfo.specification.list"
                :key="index"
              >
                <div
                  class="icon-delete"
                  @click="handleSpecificationDelete(index)"
                ></div>
                <div class="block-item">
                  <span class="label margin-right-10">规格名</span>
                  <el-select
                    v-model="item.name"
                    placeholder=""
                    class="w120"
                    @change="handleSpecificationChange(index)"
                  >
                    <el-option
                      v-for="nameItem in specificationNameOptions"
                      :key="nameItem.name"
                      :label="nameItem.name"
                      :value="nameItem.name"
                    ></el-option>
                  </el-select>
                  <el-checkbox
                    v-model="specificationPicsUploadVisible"
                    class="margin-left-20"
                    v-if="index == 0"
                    >添加规格图片</el-checkbox
                  >
                </div>
                <div class="block-item flex-h" v-if="item.name">
                  <div class="label margin-right-10">规格值</div>
                  <div class="flex-a-i clearfix">
                    <div
                      class="specification-value-item"
                      v-for="(valuesItem, valuesIndex) in item.valueNameList"
                      :key="valuesIndex"
                    >
                      <div class="input-delete-wrap">
                        <el-select
                          allow-create
                          filterable
                          v-model="valuesItem.name"
                          placeholder=""
                          class="w120"
                          @change="
                            handleSpecificationValuesSelectChange(
                              index,
                              valuesIndex,
                            )
                          "
                        >
                          <el-option
                            v-for="(vItem, vIndex) in valuesItem.valueOptions"
                            :key="vIndex"
                            :label="vItem.name"
                            :value="vItem.name"
                          ></el-option>
                        </el-select>
                        <div
                          class="btn-delete"
                          @click="
                            handleSpecificationValuesDelete(index, valuesIndex)
                          "
                          v-if="!valuesItem.loading"
                        ></div>
                        <el-button
                          type="primary"
                          size="small"
                          class="select-loading"
                          :loading="valuesItem.loading"
                          v-if="valuesItem.loading"
                        ></el-button>
                      </div>
                      <div
                        class="specification-pics-box"
                        v-if="index == 0 && specificationPicsUploadVisible"
                      >
                        <div class="pics-box">
                          <el-upload
                            :action="uploadPicUrl"
                            list-type="picture-card"
                            :data="{ index: valuesIndex }"
                            :file-list="valuesItem.picList"
                            accept=".png,.jpg,.jpeg"
                            drag
                            :on-preview="handleSpecificationPicturesPreview"
                            :on-remove="handleSpecificationPicturesRemove"
                            :on-success="handleSpecificationPicturesSuccess"
                            :on-error="handleSpecificationPicturesError"
                            :before-upload="
                              handleSpecificationPicturesBeforeUpload
                            "
                            :on-exceed="handleSpecificationPicturesExceed"
                            :limit="specificationPicsLimit"
                          >
                            <i class="el-icon-plus"></i>
                          </el-upload>
                        </div>
                      </div>
                    </div>
                    <el-button
                      type="text"
                      size="small"
                      @click="handleSpecificationValuesAdd(index)"
                      >添加规格值</el-button
                    >
                  </div>
                </div>
                <div
                  class="tips"
                  v-if="index == 0 && specificationPicsUploadVisible"
                >
                  仅支持为第一组规格设置规格图片，买家选择不同规格会看到对应规格图片，建议尺寸：800
                  x 800像素
                </div>
              </div>
              <el-button
                type="default"
                size="small"
                plain
                @click="handleSpecificationAdd"
                :disabled="formData.baseInfo.specification.list.length > 2"
                >添加规格</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="formData.baseInfo.specification.showSortButton"
                @click="handleSpecificationDialogShow"
                >自定义排序</el-button
              >
              <p class="tips">如：颜色、尺码等多种规格</p>
            </el-form-item>
            <el-form-item
              label="规格明细"
              v-if="formData.baseInfo.specification.particularData.length > 0"
              required
              :show-message="false"
            >
              <div class="grey-inline-block">
                <el-table
                  size="small"
                  :data="formData.baseInfo.specification.particularData"
                  style="width: 100%"
                  class="paticular-table"
                  :span-method="handleParticularTableRowMethod"
                >
                  <el-table-column
                    :label="formData.baseInfo.specification.list[0].name"
                    v-if="
                      formData.baseInfo.specification.list[0] &&
                      formData.baseInfo.specification.list[0].name &&
                      formData.baseInfo.specification.list[0].valueNameList
                        .length > 0
                    "
                  >
                    <template slot-scope="scope">
                      <p>{{ scope.row.firstValue }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="formData.baseInfo.specification.list[1].name"
                    v-if="
                      formData.baseInfo.specification.list[1] &&
                      formData.baseInfo.specification.list[1].name &&
                      formData.baseInfo.specification.list[1].valueNameList
                        .length > 0
                    "
                  >
                    <template slot-scope="scope">
                      <p>{{ scope.row.secondValue }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="formData.baseInfo.specification.list[2].name"
                    v-if="
                      formData.baseInfo.specification.list[2] &&
                      formData.baseInfo.specification.list[2].name &&
                      formData.baseInfo.specification.list[2].valueNameList
                        .length > 0
                    "
                  >
                    <template slot-scope="scope">
                      <p>{{ scope.row.thirdValue }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="'* 价格(' + (unit == 1 ? '₩' : '￥') + ')'"
                    width="80px"
                  >
                    <template slot-scope="scope">
                      <el-input
                        type="number"
                        v-model="scope.row.price"
                        @change="handleSetBaseInfoPrice"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="* 库存" width="80px">
                    <template slot-scope="scope">
                      <el-input
                        type="number"
                        v-model="scope.row.stock"
                        @change="handleSetBaseInfoStock"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="* 规格编码" width="80px">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.skuCode"
                        @change="updateLocalParticularData"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="成本价" width="80px">
                    <template slot-scope="scope">
                      <el-input
                        type="number"
                        v-model="scope.row.cost"
                        @change="updateLocalParticularData"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="预设销量" width="80px">
                    <template slot-scope="scope">
                      <el-input
                        type="number"
                        v-model="scope.row.presetSale"
                        @change="handleSetBaseInfoPresetSale"
                      ></el-input>
                    </template>
                  </el-table-column>
                </el-table>
                <div class="particular-toolbar">
                  <span class="text">批量设置</span>
                  <el-button
                    type="text"
                    size="small"
                    v-if="
                      !particularTools.priceInputShow &&
                      !particularTools.stockInputShow
                    "
                    @click="handleParticularSetPrice"
                    >价格</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="
                      !particularTools.stockInputShow &&
                      !particularTools.priceInputShow
                    "
                    @click="handleParticularSetStock"
                    >库存</el-button
                  >
                  <!-- price -->
                  <el-input
                    type="number"
                    size="small"
                    v-model="particularTools.price"
                    v-if="particularTools.priceInputShow"
                    class="w70 margin-left-10"
                  ></el-input>
                  <el-button
                    type="text"
                    size="small"
                    v-if="particularTools.priceInputShow"
                    @click="handleParticularSetPriceSubmit"
                    >保存</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="particularTools.priceInputShow"
                    @click="handleParticularSetPriceCancel"
                    >取消</el-button
                  >
                  <!-- stock -->
                  <el-input
                    type="number"
                    size="small"
                    v-model="particularTools.stock"
                    v-if="particularTools.stockInputShow"
                    class="w70 margin-left-10"
                  ></el-input>
                  <el-button
                    type="text"
                    size="small"
                    v-if="particularTools.stockInputShow"
                    @click="handleParticularSetStockSubmit"
                    >保存</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    v-if="particularTools.stockInputShow"
                    @click="handleParticularSetStockCancel"
                    >取消</el-button
                  >
                </div>
              </div>
            </el-form-item>
            <el-form-item label="价格" required :show-message="false">
              <template v-if="unit == 1">
                <el-input
                  type="number"
                  v-model="formData.baseInfo.koreaPrice"
                  class="w150"
                  @change="handlePriceChange"
                >
                  <template slot="prepend">
                    <el-select v-model="unit" @change="handlePriceUnitSwitch">
                      <el-option
                        v-for="(row, rowIndex) in unitOptions"
                        :value="row.value"
                        :label="row.label"
                        :key="rowIndex"
                      ></el-option>
                    </el-select>
                  </template>
                </el-input>
              </template>
              <template v-else>
                <el-input
                  type="number"
                  v-model="formData.baseInfo.price"
                  class="w150"
                  @change="handlePriceChange"
                >
                  <template slot="prepend">
                    <el-select v-model="unit" @change="handlePriceUnitSwitch">
                      <el-option
                        v-for="(row, rowIndex) in unitOptions"
                        :value="row.value"
                        :label="row.label"
                        :key="rowIndex"
                      ></el-option>
                    </el-select>
                  </template>
                </el-input>
              </template>
            </el-form-item>
            <el-form-item label="汇率（人民币兑韩元）">
              <el-input
                type="number"
                v-model.number="cnyToKrwRate"
                step="0.01"
                class="w150"
                @change="handleCnyToKrwRateChange"
              ></el-input>
            </el-form-item>
            <!-- <el-form-item label="划线价">
                  <el-input type="number" v-model="formData.baseInfo.nickPrice" class="w150">
                    <template slot="prepend">
                      <el-select v-model="unit" disabled>
                        <template v-for="(row, rowIndex) in unitOptions">
                          <el-option :value="row.value" :label="row.label" :key="rowIndex"></el-option>
                        </template>
                      </el-select>
                    </template>
                  </el-input>
                </el-form-item> -->
            <el-form-item label="库存" required :show-message="false">
              <el-input
                type="number"
                v-model="formData.baseInfo.stock"
                class="w150"
                :disabled="formData.baseInfo.stock > -1"
              ></el-input>
              <p class="tips">库存为 0 时，会放到 [已售罄] 的商品列表里</p>
            </el-form-item>
            <!-- <el-form-item label="预设销量">
                  <el-input type="number" v-model="formData.baseInfo.presetSale" class="w150"
                    :disabled="true"></el-input>
                </el-form-item> -->
          </div>
        </div>
        <!-- 物流信息 -->
        <!-- <div class="form-module" v-if="formData.baseInfo.type == '0'">
                            <div class="module-header">物流信息</div>
                            <div class="module-body">
                                <el-form-item label="配送方式" required :show-message="false">
                                    <p class="text">快递发货</p>
                                </el-form-item>
                                <el-form-item label="快递运费" required :show-message="false">
                                    <div class="radio-block">
                                        <el-radio v-model="formData.deliverInfo.feeType" label="0" @change="handleDeliverFeeTypeChange">统一邮费</el-radio>
                                        <el-input type="number" v-model="formData.deliverInfo.deliverFee" class="w150">
                                            <template slot="prepend">¥</template>
                                        </el-input>
                                    </div>
                                    <div class="radio-block">
                                        <el-radio v-model="formData.deliverInfo.feeType" label="1" @change="handleDeliverFeeTypeChange">运费模板</el-radio>
                                        <el-select v-model="formData.deliverInfo.shippingTemplatesId" placeholder="请选择运费模板" filterable class="w150" @change="handleDeliverWeightTypeChange">
                                            <el-option v-for="item in shippingTemplatesOptions" :key="item.id" :label="item.name" :value="item.id" v-if="formData.deliverInfo.feeType == 1"></el-option>
                                        </el-select>
                                        <el-button type="text" @click="handleGetCommodityShippingTemplateList" :loading="shippingTemplatesOptionsLoading" v-if="formData.deliverInfo.feeType == 1">刷新</el-button>
                                        <router-link target="_blank" class="router-link-active" :to="{ path: '/order/express/add' }" v-if="formData.deliverInfo.feeType == 1">新建运费模板</router-link>
                                        <p class="tips" v-if="!(formData.deliverInfo.feeType == '1' && !!formData.deliverInfo.showWeight)">运费模板支持按地区设置运费，按购买件数计算运费，按重量计算运费等</p>

                                        <el-form-item label="物流重量" v-if="formData.deliverInfo.feeType == '1' && !!formData.deliverInfo.showWeight" label-width="85px" style="margin-top: 10px;" required :show-message="false">
                                            <div class="radio-block">
                                                <el-radio v-model="formData.deliverInfo.weightType" label="0">所有商品规格统一重量</el-radio>
                                                <el-input type="number" v-model="formData.deliverInfo.weight" class="w150" @change="handleSameWeightChange">
                                                    <template slot="prepend">Kg</template>
                                                </el-input>
                                            </div>
                                            <div class="radio-block">
                                                <el-radio v-model="formData.deliverInfo.weightType" label="1">不同商品规格单独设置重量</el-radio>
                                                <div v-if="formData.deliverInfo.weightType == '1'">
                                                    <div class="grey-inline-block">
                                                        <el-table size="small" :data="formData.baseInfo.specification.particularData" style="width: 100%" class="paticular-table" :span-method="handleParticularTableRowMethod">
                                                            <el-table-column :label="formData.baseInfo.specification.list[0].name" v-if="formData.baseInfo.specification.list[0] && formData.baseInfo.specification.list[0].name && formData.baseInfo.specification.list[0].valueNameList.length > 0">
                                                                <template slot-scope="scope">
                                                                    <p>{{ scope.row.firstValue }}</p>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column :label="formData.baseInfo.specification.list[1].name" v-if="formData.baseInfo.specification.list[1] && formData.baseInfo.specification.list[1].name && formData.baseInfo.specification.list[1].valueNameList.length > 0">
                                                                <template slot-scope="scope">
                                                                    <p>{{ scope.row.secondValue }}</p>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column :label="formData.baseInfo.specification.list[2].name" v-if="formData.baseInfo.specification.list[2] && formData.baseInfo.specification.list[2].name && formData.baseInfo.specification.list[2].valueNameList.length > 0">
                                                                <template slot-scope="scope">
                                                                    <p>{{ scope.row.thirdValue }}</p>
                                                                </template>
                                                            </el-table-column>
                                                            <el-table-column label="* 重量(Kg)" width="80px">
                                                                <template slot-scope="scope">
                                                                    <el-input type="number" v-model="scope.row.weight" @change="updateLocalParticularData"></el-input>
                                                                </template>
                                                            </el-table-column>
                                                        </el-table>
                                                        <div class="particular-toolbar">
                                                            <span class="text">批量设置</span>
                                                            <el-button type="text" size="small" v-if="!particularTools.weightInputShow" @click="handleParticularSetWeight">重量</el-button>
                                                            <el-input type="number" size="small" v-model="particularTools.weight" v-if="particularTools.weightInputShow" class="w70 margin-left-10"></el-input>
                                                            <el-button type="text" size="small" v-if="particularTools.weightInputShow" @click="handleParticularSetWeightSubmit">保存</el-button>
                                                            <el-button type="text" size="small" v-if="particularTools.weightInputShow" @click="handleParticularSetWeightCancel">取消</el-button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p class="tips" style="margin: 10px 0 0 0;" v-if="formData.deliverInfo.weightType == '1'">当前运费模板，按物流重量（含包装）计费，需要输入重量</p>
                                            </div>
                                        </el-form-item>
                                    </div>
                                </el-form-item>
                            </div>
                        </div> -->
        <div class="form-button-wrap">
          <el-button type="primary" size="small" @click="handleChangeStep(2)"
            >下一步</el-button
          >
        </div>
      </el-form>
    </div>
    <!-- step 2 -->
    <div class="step-content" v-show="step == 2">
      <el-form
        size="small"
        ref="detailFormData"
        label-width="150px"
        class="content-form"
      >
        <!-- 基本信息 -->
        <div class="form-module">
          <div class="module-header">商品详情</div>
          <div class="module-body">
            <el-form-item label="详情图" required :show-message="false">
              <div class="pics-box pics-box-detail">
                <el-upload
                  :action="uploadPicUrl"
                  list-type="picture-card"
                  :file-list="detailUploadPicList"
                  accept=".png,.jpg,.jpeg"
                  drag
                  :on-preview="handleDetailPicturesPreview"
                  :on-remove="handleDetailPicturesRemove"
                  :on-success="handleDetailPicturesSuccess"
                  :on-error="handleDetailPicturesError"
                  :before-upload="handleDetailPicturesBeforeUpload"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
              <p class="tips">
                支持jpg、png格式，上传数量不限，单张图片不超过2M
              </p>
            </el-form-item>
          </div>
        </div>

        <div class="form-button-wrap">
          <el-button type="default" size="small" @click="handleChangeStep(1)"
            >上一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            @click="handleFormSubmit('formData')"
            :loading="submitLoading"
            >保存</el-button
          >
        </div>
      </el-form>
    </div>

    <!-- 规格拖动排序 dialog -->
    <el-dialog
      title="拖动规格值进行排序"
      :visible.sync="specificationSortDialogShow"
      width="400px"
      custom-class="sort-dialog"
      @opened="handleSpecificationDialogOpened"
      @close="handleSpecificationDialogClose"
    >
      <el-form
        size="small"
        label-width="80px"
        label-position="top"
        class="dialog-form"
      >
        <el-form-item
          v-for="(itemName, itemNameIndex) in formData.baseInfo.specification
            .listClone"
          :key="itemNameIndex"
          :label="itemName.name"
        >
          <p
            :class="'sort-item sort-item-' + itemNameIndex"
            v-for="(itemValue, itemValueIndex) in itemName.valueNameList"
            :key="itemValueIndex + 1"
            :data-nindex="itemNameIndex"
            :data-vindex="itemValueIndex"
          >
            {{ itemValue.name }}
          </p>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" plain @click="handleSpecificationDialogHide"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="handleSpecificationDialogSubmit"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 图片预览 -->
    <el-dialog
      :visible.sync="previewDialogShow"
      custom-class="preview-image-dialog"
    >
      <img width="100%" :src="previewDialogImageUrl" alt="" />
    </el-dialog>
    <!-- 视频预览 -->
    <el-dialog
      :visible.sync="previewVideoDialogShow"
      custom-class="preview-video-dialog"
    >
      <video
        width="100%"
        style="height: calc(70vh - 60px)"
        :src="previewVideoDialogUrl"
        controls
        alt=""
      ></video>
    </el-dialog>
  </section>
</template>

<script>
import {
  BASE,
  uploadPath,
  commodityCategoryList,
  commodityCategoryLabelList,
  commoditySpecificationList,
  commoditySpecificationValueAdd,
  commodityShippingTemplateList,
  commoditySave,
  commodityDetail,
  validGoodsName,
  commodityOptionWarehouseList,
  commodityOptionRegionList,
  commodityOptionRateList,
  commodityGetLatestRate,
} from "@/common/api";

export default {
  name: "goodsManageAdd",
  data() {
    return {
      id: this.$route.query.id || "",
      pageLoading: true,

      step: 1, // 当前步骤

      formData: {
        // 表单数据
        baseInfo: {
          // 基本信息
          sort: 0, // 排序号
          regionId: "", // 产地
          rateId: "", // 税率
          includeTax: "",
          warehouseId: "", // 仓库
          type: "0", // 0: 实体商品； 1: 虚拟商品
          abroadType: "1", // 1: 国内； 2: 国外
          commodityType: "1", // 1: 普通商品； 2: 专链商品
          name: "", // 商品名
          code: "", // 商品编码
          categoryList: [
            {
              firstCategoryId: "",
              secondCategoryId: "",
              categoryLabelId: "",
              secondCategoryOptions: [],
              categoryLabelOptions: [],
            },
          ],
          sellingPoint: "", // 卖点
          pics: [], // 图
          tags: [
            {
              label: "",
            },
          ], // 标签
          specification: {
            showSortButton: false, // 是否显示自定义排序按钮
            list: [
              // {
              //     id: '',
              //     name: '', // 规格名
              //     valueNameList: [  // 已选规格值列表
              //         {
              //             name: '',
              //             valueOptions: [] // 规格值下拉列表
              //         }
              //     ]
              // }
            ],

            listClone: [],

            particularData: [
              // 规格明细
              // {
              //     firstValue: '',
              //     secondValue: '',
              //     thirdValue: '',
              //     price: '',
              //     stock: '',
              //     skuCode: '',
              //     cost: '',
              //     presetSale: 0
              // }
            ],
          }, // 商品规格
          price: "", // 价格
          nickPrice: "", //划线价
          koreaPrice: "",
          koreaNickPrice: "",
          stock: "", // 库存
          presetSale: "", //预售销量
        },

        deliverInfo: {
          // 物流信息
          deliverType: "0", // 配送方式
          feeType: "", // 收费类型
          deliverFee: "", // 运费
          shippingTemplatesId: "", // 运费模板
          showWeight: false, // 是否显示重量
          weightType: "0", // 重量类型
          weight: "", // 重量
        },
      },
      submitLoading: false,

      // 主图视频
      videosLimit: 1,
      uploadVideoList: [],
      previewVideoDialogShow: false,
      previewVideoDialogUrl: "",

      firstCategoryOptions: [], // 商品类目列表
      firstCategoryOptionsLoading: true,

      specificationPicsUploadVisible: false, // 添加图片
      specificationOptions: [], // 规格数据
      specificationNameOptions: [], // 下拉规格名列表
      specificationValueOptions: [], // 下拉规格值列表
      specificationOptionsLoading: true,

      localParticularData: [], // 本地缓存的规格明细数据

      particularTools: {
        // 规格明细批量设置
        price: "", // 批量设置价格
        priceInputShow: false, //
        stock: "", // 批量设置库存
        stockInputShow: false,
        weight: "",
        weightInputShow: false,
      },

      uploadPicUrl: BASE + "/commodity/uploadPic", // 图片上传地址
      previewDialogShow: false,
      previewDialogImageUrl: "",
      // 商品图
      picsLimit: 6,
      uploadPicList: [],
      // 规格图片
      specificationPicsLimit: 1,
      // 详情图片
      detailPics: [],
      detailUploadPicList: [],

      warehouseOptions: [], // 仓库
      warehouseOptionsLoading: false,
      regionOptions: [], // 产地
      regionOptionsLoading: false,
      rateOptions: [], // 税率
      rateOptionsLoading: false,

      shippingTemplatesOptions: [], // 运费模版下拉列表
      shippingTemplatesOptionsLoading: true,

      specificationSortDialogShow: false, // 规格排序弹窗显隐
      sorting: false,
      unit: 0,
      unitOptions: [
        {
          value: 0,
          label: "￥",
        },
        {
          value: 1,
          label: "₩",
        },
      ],
      latestRateOrigin: 1,
      latestRate: 1, // 存储：1韩元 = latestRate人民币
      cnyToKrwRate: 1.0, // 显示：1人民币 = cnyToKrwRate韩元
    };
  },
  watch: {
    // 监听图片数量变化，绑定排序事件
    uploadPicList: function (val) {
      this.watchUploadPicList();
    },
    // 监听详情图片数量变化，绑定排序事件
    detailUploadPicList: function (val) {
      this.watchDetailUploadPicList();
    },
  },
  mounted() {
    this.getLatestRate();
    this.getWarehouseList();
    this.getRegionList();
    this.getRateList();
    this.getFirstCategoryList();
    this.handleGetCommodityShippingTemplateList();
  },
  methods: {
    //  获取人民币/韩元汇率
    getLatestRate: function () {
      commodityGetLatestRate({}).then((res) => {
        let { code, data, msg } = res.data;
        if (code == 0) {
          this.latestRate = data || 1;
          this.latestRateOrigin = data || 1;
          // 同步更新显示的人民币兑韩元汇率
          this.cnyToKrwRate =
            data && data > 0 ? parseFloat((1 / data).toFixed(2)) : 1.0;
          this.handleGetSpecificationList();
        }
      });
    },
    // 获取仓库
    getWarehouseList: function (isRefresh) {
      this.warehouseOptionsLoading = true;
      commodityOptionWarehouseList({}).then((res) => {
        let { code, data, msg } = res;
        if (code == 0) {
          this.warehouseOptions = data || [];
          this.warehouseOptionsLoading = false;
        }
      });
    },
    //  获取产地
    getRegionList: function (isRefresh) {
      this.regionOptionsLoading = true;
      commodityOptionRegionList({}).then((res) => {
        let { code, data, msg } = res;
        if (code == 0) {
          this.regionOptions = data || [];
          this.regionOptionsLoading = false;
        }
      });
    },
    //  获取税率
    getRateList: function (isRefresh) {
      this.rateOptionsLoading = true;
      commodityOptionRateList({}).then((res) => {
        let { code, data, msg } = res;
        if (code == 0) {
          if (data && data.length > 0) {
            data.map((row) => {
              row.rateLabel = row.rate + "%";
            });
          }
          this.rateOptions = data || [];
          this.rateOptionsLoading = false;
        }
      });
    },
    // 校验商品名称是否重复
    handleValidGoodsName: function () {
      let params = {
        id: this.id,
        name: this.formData.baseInfo.name,
      };

      validGoodsName(params)
        .then((res) => {
          let { code, data, msg } = res;
          if (code != 0) {
            this.$message.error(msg);
          }
        })
        .catch((error) => {});
    },
    // 图片数量变化，绑定排序事件
    watchUploadPicList: function () {
      this.formData.baseInfo.pics = [];
      for (let i = 0; i < this.uploadPicList.length; i++) {
        // this.formData.baseInfo.pics.push(this.uploadPicList[i].response.data.url);
        this.formData.baseInfo.pics.push(
          this.uploadPicList[i].response.data.path,
        );
      }

      this.$nextTick(function () {
        this.handlePicListSort();
      });
    },
    // 详情图片数量变化，绑定排序事件
    watchDetailUploadPicList: function () {
      this.detailPics = [];
      for (let i = 0; i < this.detailUploadPicList.length; i++) {
        this.detailPics.push(this.detailUploadPicList[i].response.data.path);
        // this.detailPics.push(this.detailUploadPicList[i].response.data.url);
      }

      this.$nextTick(function () {
        this.handleDetailPicListSort();
      });
    },
    // 切换基本信息
    handleBaseInfoChange: function (field, value) {
      if (this.formData.baseInfo[field] == value) {
        return false;
      }
      this.formData.baseInfo[field] = value;
    },
    // 获取详情
    getDetail: function () {
      if (!this.id) {
        this.pageLoading = false;
        this.handleCreateSpecificationNameOptions();
        return false;
      }

      this.pageLoading = true;

      let params = {
        id: this.id,
      };

      commodityDetail(params)
        .then((res) => {
          let { code, data, msg } = res;

          if (code == 0) {
            this.pageLoading = false;

            this.formData.baseInfo.regionId = data.regionId
              ? "" + data.regionId
              : "";
            this.formData.baseInfo.rateId = data.rateId ? "" + data.rateId : "";
            this.formData.baseInfo.includeTax = data.includeTax
              ? "" + data.includeTax
              : "";
            this.formData.baseInfo.warehouseId = data.warehouseId
              ? "" + data.warehouseId
              : "";

            this.formData.baseInfo.name = data.name;
            this.formData.baseInfo.type = "" + data.type;
            this.formData.baseInfo.abroadType = data.abroadType;
            this.formData.baseInfo.commodityType = data.commodityType;
            this.formData.baseInfo.sort = data.sort;
            this.formData.baseInfo.code = data.code;

            // 商品类目
            if (data.categoryLabelCommodityList.length > 0) {
              let categoryArr = [];

              for (let i = 0; i < data.categoryLabelCommodityList.length; i++) {
                let item = data.categoryLabelCommodityList[i];

                categoryArr.push({
                  firstCategoryId: "" + item.firstCategoryId,
                  secondCategoryId: "" + item.secondCategoryId,
                  categoryLabelId: "" + item.categoryLabelId,
                  secondCategoryOptions: [],
                  categoryLabelOptions: [],
                });
              }

              this.formData.baseInfo.categoryList = categoryArr;
              this.handleGetCategoryOptions();
            }

            // 卖点
            this.formData.baseInfo.sellingPoint = data.sellingPoint;

            // 主图视频
            if (data.mainVideo) {
              let picsItemArr = data.mainVideoPath.split("/"),
                picsItemName = picsItemArr[picsItemArr.length - 1];
              this.uploadVideoList = [
                {
                  name: picsItemName,
                  percentage: 100,
                  status: "success",
                  url: data.mainVideoPath,
                  response: {
                    data: {
                      path: data.mainVideoPath,
                      url: data.mainVideo,
                    },
                  },
                },
              ];
            }

            // 商品图
            let picsList = data.listPic;
            if (picsList.length == 0) {
              this.formData.baseInfo.pics = [];
              this.uploadPicList = [];
            } else {
              for (let i = 0; i < picsList.length; i++) {
                let picsItem = picsList[i],
                  picsItemArr = picsItem.url.split("/"),
                  picsItemName = picsItemArr[picsItemArr.length - 1];
                this.uploadPicList.push({
                  name: picsItemName,
                  percentage: 100,
                  status: "success",
                  url: picsItem.path,
                  response: {
                    data: {
                      url: picsItem.path,
                      path: picsItem.url,
                    },
                  },
                });
              }

              this.watchUploadPicList();
            }

            // 标签
            if (data.labels && data.labels.length > 0) {
              let tagsArr = [];

              for (let i = 0; i < data.labels.length; i++) {
                tagsArr.push({
                  label: data.labels[i],
                });
              }

              this.formData.baseInfo.tags = tagsArr;
            }

            // 商品规格
            if (data.specificationJson.length > 0) {
              let specificationArr = [];
              for (let i = 0; i < data.specificationJson.length; i++) {
                let item = data.specificationJson[i],
                  valueNameList = [];

                if (i == 0 && item.valueNameList.length > 0) {
                  // 判断第一组规格是否有图
                  let num = 0;
                  for (let j = 0; j < item.valueNameList.length; j++) {
                    let valueItem = item.valueNameList[j];

                    if (valueItem.url) {
                      valueNameList.push({
                        name: valueItem.name,
                        picList: [
                          {
                            name: valueItem.path,
                            percentage: 100,
                            status: "success",
                            url: valueItem.path,
                            response: {
                              data: {
                                url: valueItem.url,
                                path: valueItem.path,
                              },
                            },
                          },
                        ],
                      });

                      num += 1;
                    } else {
                      valueNameList.push({
                        name: valueItem.name,
                        picList: [],
                      });
                    }
                  }

                  this.specificationPicsUploadVisible = num > 0 ? true : false;
                } else {
                  valueNameList = item.valueNameList;
                }

                specificationArr.push({
                  id: "" + item.id,
                  name: item.name,
                  valueNameList: valueNameList,
                });
              }

              this.formData.baseInfo.specification.list = specificationArr;
              this.formData.baseInfo.specification.showSortButton = true;
            }
            this.handleCreateSpecificationNameOptions();
            this.handleCreateSpecificationValueOptions();

            // 规格明细
            for (let i = 0; i < data.specificationDetailJson.length; i++) {
              let item = data.specificationDetailJson[i];

              if (item.weight == 0) {
                item.weight = "";
              }

              this.formData.baseInfo.specification.particularData.push(item);
            }
            this.updateLocalParticularData();

            this.unit = data.unit || 0;
            // 人民币
            this.formData.baseInfo.price = data.price;
            this.formData.baseInfo.nickPrice = data.nickPrice;
            // 韩币
            this.formData.baseInfo.koreaPrice = data.koreaPrice;
            this.formData.baseInfo.koreaNickPrice = data.koreaNickPrice;
            this.formData.baseInfo.stock = data.stock;
            this.formData.baseInfo.presetSale = data.presetSale;

            if (data.customRate) {
              this.latestRateOrigin = data.customRate;
              this.latestRate = data.customRate;
              // 同步更新显示的人民币兑韩元汇率
              this.cnyToKrwRate =
                data.customRate > 0
                  ? parseFloat((1 / data.customRate).toFixed(2))
                  : 1.0;
            }

            // 物流信息设置
            let deliverInfo = data.commodityDeliverVo;
            if (deliverInfo) {
              this.formData.deliverInfo.deliverType =
                "" + deliverInfo.deliverType;
              this.formData.deliverInfo.feeType = "" + deliverInfo.feeType;
              this.formData.deliverInfo.deliverFee = deliverInfo.deliverFee;
              this.formData.deliverInfo.shippingTemplatesId =
                deliverInfo.shippingTemplatesId
                  ? "" + deliverInfo.shippingTemplatesId
                  : "";
              this.handleDeliverWeightTypeChange(
                deliverInfo.shippingTemplatesId,
              );
              this.formData.deliverInfo.weightType =
                "" + deliverInfo.weightType;
              this.formData.deliverInfo.weight =
                deliverInfo.weightType == "0"
                  ? data.specificationDetailJson[0].weight
                  : "";
              this.formData.deliverInfo.showWeight =
                deliverInfo.feeType == 1 && deliverInfo.templateType == 2
                  ? true
                  : false;
            } else {
              this.formData.baseInfo.deliverInfo = {
                deliverType: "0",
                feeType: "",
                deliverFee: "",
                shippingTemplatesId: "",
                showWeight: false,
                weightType: "0",
                weight: "",
              };
            }

            // 详情图
            if (data.detailPic.length == 0) {
              this.detailPics = [];
              this.detailUploadPicList = [];
            } else {
              for (let i = 0; i < data.detailPic.length; i++) {
                let picsItem = data.detailPic[i];

                this.detailUploadPicList.push({
                  name: picsItem.path,
                  percentage: 100,
                  status: "success",
                  url: picsItem.path,
                  response: {
                    data: {
                      url: picsItem.path,
                      path: picsItem.url,
                    },
                  },
                });
              }

              this.watchDetailUploadPicList();
            }
          } else {
            this.$message.error(msg);
          }
        })
        .catch((error) => {
          this.$message.error("服务器异常");
        });
    },
    // 获取二类目、类目标签下拉列表
    handleGetCategoryOptions: function () {
      let list = this.formData.baseInfo.categoryList;

      if (list.length == 0) {
        return false;
      }

      for (let i = 0; i < list.length; i++) {
        this.handleFirstCategoryChange(i);
        this.handleSecondCategoryChange(i);
      }
    },
    //  添加类目
    handleCategoryAdd: function () {
      this.formData.baseInfo.categoryList.push({
        firstCategoryId: "",
        secondCategoryId: "",
        categoryLabelId: "",
        secondCategoryOptions: [],
        categoryLabelOptions: [],
      });
    },
    // 删除类目
    handleCategoryDelete: function (index) {
      this.formData.baseInfo.categoryList.splice(index, 1);
    },
    // 获取商品类目 isRefresh 表示这个操作是刷新
    getFirstCategoryList: function (isRefresh) {
      this.firstCategoryOptionsLoading = true;

      let params = {
        type: 1,
      };

      commodityCategoryList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          this.firstCategoryOptions = dataArray;
          this.firstCategoryOptionsLoading = false;

          if (isRefresh) {
            this.$message({ message: "商品类目已刷新", type: "success" });
          }
        }
      });
    },
    // 监测一级类目下拉框值变化
    handleFirstCategoryChange: function (index, type) {
      if (type == "user") {
        this.formData.baseInfo.categoryList[index].secondCategoryId = "";
        this.formData.baseInfo.categoryList[index].categoryLabelId = "";
      }

      let categoryList = this.formData.baseInfo.categoryList,
        firstCategoryId = categoryList[index].firstCategoryId;

      let params = {
        type: 1,
        firstCategoryId: firstCategoryId,
      };

      commodityCategoryList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          categoryList[index].secondCategoryOptions = dataArray;
        }
      });
    },
    // 监测二级类目下拉框值变化
    handleSecondCategoryChange: function (index, type) {
      if (type == "user") {
        this.formData.baseInfo.categoryList[index].categoryLabelId = "";
      }

      let categoryList = this.formData.baseInfo.categoryList,
        secondCategoryId = categoryList[index].secondCategoryId;

      let params = {
        secondCategoryId: secondCategoryId,
      };

      commodityCategoryLabelList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data || [];

          categoryList[index].categoryLabelOptions = dataArray;
        }
      });
    },
    // 添加标签
    handleTagsAdd: function () {
      this.formData.baseInfo.tags.push({
        label: "",
      });
    },
    // 移除标签
    handleTagsDelete: function (index) {
      this.formData.baseInfo.tags.splice(index, 1);
    },
    // 获取规格列表
    handleGetSpecificationList: function () {
      let params = {};

      commoditySpecificationList(params).then((res) => {
        let { code, data, msg } = res;

        if (code == 0) {
          this.specificationOptions = data || [];

          this.getDetail();
        }
      });
    },
    // 创建规格名的下拉列表，剔除已选中的规格名
    handleCreateSpecificationNameOptions: function () {
      this.specificationNameOptions = [];

      if (this.specificationOptions.length > 0) {
        for (let i = 0; i < this.specificationOptions.length; i++) {
          let item = this.specificationOptions[i];

          if (!this.handleCheckSpecificationNameIsExits(item.name)) {
            this.specificationNameOptions.push({
              id: item.id,
              name: item.name,
            });
          }
        }
      }
    },
    // 校验规格名是否已在已选中规格名里面
    handleCheckSpecificationNameIsExits: function (name) {
      let list = this.formData.baseInfo.specification.list;

      if (list.length == 0) {
        return false;
      }

      for (let i = 0; i < list.length; i++) {
        if (list[i].name == name) {
          return true;
        }

        if (i == list.length - 1) {
          return false;
        }
      }
    },
    // 在已选择的规格值列表中循环插入规格值下拉列表
    handleCreateSpecificationValueOptions: function () {
      let list = this.formData.baseInfo.specification.list,
        listClone = [];

      if (list.length == 0) {
        return false;
      }

      // 循环选中规格名列表
      for (let i = 0; i < list.length; i++) {
        let values = list[i].valueNameList;

        if (values.length > 0) {
          //循环选中规格值列表
          for (let j = 0; j < values.length; j++) {
            // 每个规格值item添加下拉列表
            values[j].valueOptions =
              this.handleCreateSpecificationValueOptionsItem(i, list[i].name);
          }
        }
      }
    },
    // 根据规格名创建规格值的下拉列表，剔除已选中的规格值
    handleCreateSpecificationValueOptionsItem: function (nameIndex, name) {
      let valueOptions = [];

      // 循环元数据规格名列表
      for (let i = 0; i < this.specificationOptions.length; i++) {
        // 元数据规格名 == 选中规格名
        if (this.specificationOptions[i].name == name) {
          let nameValues = this.specificationOptions[i].nameValues;

          // 循环元数据规格名下的规格值列表
          for (let j = 0; j < nameValues.length; j++) {
            // 若元数据规格名下的规格值列表中的规格值存在于已选中规格值列表中
            if (
              !this.handleCheckSpecificationValuesIsExits(
                nameIndex,
                nameValues[j],
              )
            ) {
              valueOptions.push({
                name: nameValues[j],
              });
            }
          }

          return valueOptions;
        }
      }
    },
    // 校验规格值是否已在已选中规格值里面
    handleCheckSpecificationValuesIsExits: function (nameIndex, value) {
      let list =
        this.formData.baseInfo.specification.list[nameIndex].valueNameList; //已选中规格明下的已选中规格值列表

      // 长度为0 =》不存在
      if (list.length == 0) {
        return false;
      }

      for (let i = 0; i < list.length; i++) {
        // 值相同 =》存在
        if (list[i].name == value) {
          return true;
        }

        // 没找到 =》不存在
        if (i == list.length - 1) {
          return false;
        }
      }
    },
    // 商品规格添加模块
    handleSpecificationAdd: function () {
      this.formData.baseInfo.specification.list.push({
        id: "",
        name: "", // 规格名
        valueNameList: [
          {
            name: "",
            picList: [],
            valueOptions: [],
          },
        ], // 规格值
      });

      this.handleCreateSpecificationValueOptions();
      this.handlePackageSpecificationToParticular();
    },
    // 商品规格名删除模块
    handleSpecificationDelete: function (index) {
      this.formData.baseInfo.specification.list.splice(index, 1);

      this.handleCreateSpecificationNameOptions();
      this.handlePackageSpecificationToParticular();
      this.handleSpecificationValuesChange();
    },
    // 商品规格-规格名变化
    handleSpecificationChange: function (index) {
      this.formData.baseInfo.specification.list[index].valueNameList = [
        {
          name: "",
          picList: [],
          valueOptions: [],
        },
      ];

      this.handleGetSpecificationID(index);
      this.handleCreateSpecificationNameOptions();
      this.handleCreateSpecificationValueOptions();
      this.handlePackageSpecificationToParticular();
    },
    // 获取规格名name
    handleGetSpecificationID: function (index) {
      let name = this.formData.baseInfo.specification.list[index].name;

      for (let i = 0; i < this.specificationOptions.length; i++) {
        if (this.specificationOptions[i].name == name) {
          this.formData.baseInfo.specification.list[index].id =
            "" + this.specificationOptions[i].id;
          break;
        }
      }
    },
    // 商品规格-添加规格值
    handleSpecificationValuesAdd: function (index) {
      this.formData.baseInfo.specification.list[index].valueNameList.push({
        name: "",
        picList: [],
        valueOptions: [],
      });

      this.handleCreateSpecificationValueOptions();
      this.handlePackageSpecificationToParticular();
    },
    // 商品规格-删除规格值
    handleSpecificationValuesDelete: function (index, valueIndex) {
      this.formData.baseInfo.specification.list[index].valueNameList.splice(
        valueIndex,
        1,
      );

      this.handleCreateSpecificationValueOptions();
      this.handlePackageSpecificationToParticular();
      this.handleSpecificationValuesChange();
    },
    // 规格值下拉框值变化
    handleSpecificationValuesSelectChange: function (listIndex, valueIndex) {
      let list = this.formData.baseInfo.specification.list,
        id = list[listIndex].id,
        valueNameList = list[listIndex].valueNameList,
        valueName = valueNameList[valueIndex].name;

      for (let i = 0; i < this.specificationOptions.length; i++) {
        if (this.specificationOptions[i].id == id) {
          let nameValues = this.specificationOptions[i].nameValues;

          if (nameValues.indexOf(valueName) < 0) {
            // 规格值为新添
            valueNameList[valueIndex].loading = true;

            let params = {
              skuOptionsNameId: id,
              name: valueName,
            };

            commoditySpecificationValueAdd(params).then((res) => {
              let { code, data, msg } = res;

              if (code == 0) {
                valueNameList[valueIndex].loading = false;
                nameValues.push(valueName);
                this.handleSpecificationValuesChange();
              } else {
                valueNameList[valueIndex].loading = false;
                valueNameList.splice(valueIndex, 1);
              }
            });
          } else {
            this.handleSpecificationValuesChange();
          }

          break;
        }
      }
    },
    // 检测规格值变化，控制自定义排序按钮显示隐藏（规格模块删除、规格值删除、规格值选择 3种情形下触发）
    handleSpecificationValuesChange: function () {
      this.formData.baseInfo.specification.showSortButton = false;

      let list = this.formData.baseInfo.specification.list;
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let valueCount = 0,
            values = list[i].valueNameList;

          if (values.length > 0) {
            for (let j = 0; j < values.length; j++) {
              if (values[j].name) {
                valueCount += 1;
              }

              if (j == values.length - 1) {
                if (valueCount == 1) {
                  this.formData.baseInfo.specification.showSortButton = false;

                  this.handleCreateSpecificationValueOptions();
                  this.handlePackageSpecificationToParticular();

                  break;
                } else if (valueCount > 1) {
                  this.formData.baseInfo.specification.showSortButton = true;

                  this.handleCreateSpecificationValueOptions();
                  this.handlePackageSpecificationToParticular();

                  break;
                }
              }
            }
          }
        }
      }
    },
    // 将规格数据封装成明细列表
    handlePackageSpecificationToParticular: function () {
      let list = this.formData.baseInfo.specification.list,
        particularData = [],
        firstLen = this.handleGetSpecificationValuesLenthMethod(0) || 1,
        secondLen = this.handleGetSpecificationValuesLenthMethod(1) || 1,
        thirdLen = this.handleGetSpecificationValuesLenthMethod(2) || 1;

      if (
        this.handleGetSpecificationValuesLenthMethod(0) == 0 &&
        this.handleGetSpecificationValuesLenthMethod(1) == 0 &&
        this.handleGetSpecificationValuesLenthMethod(2) == 0
      ) {
        this.formData.baseInfo.specification.particularData = particularData;
        return false;
      }

      for (let i = 0; i < firstLen; i++) {
        for (let j = 0; j < secondLen; j++) {
          for (let k = 0; k < thirdLen; k++) {
            particularData.push({
              firstValue:
                list[0] && list[0].valueNameList.length > 0
                  ? list[0].valueNameList[i].name
                  : "",
              secondValue:
                list[1] && list[1].valueNameList.length > 0
                  ? list[1].valueNameList[j].name
                  : "",
              thirdValue:
                list[2] && list[2].valueNameList.length > 0
                  ? list[2].valueNameList[k].name
                  : "",
              price: "",
              stock: "",
              skuCode: "",
              cost: "",
              weight: "",
              presetSale: "",
            });
          }
        }
      }

      this.formData.baseInfo.specification.particularData = particularData;

      this.updateLocalParticularData();
    },
    //  更新本地缓存的规格明细数据
    updateLocalParticularData: function () {
      let newData = this.formData.baseInfo.specification.particularData;

      if (newData.length == 0) {
        return false;
      }

      if (this.localParticularData.length == 0) {
        // 本地缓存为空，直接插入数据
        for (let i = 0; i < newData.length; i++) {
          let newItem = newData[i];

          this.localParticularData.push(newItem);
        }
      } else {
        // 本地缓存不为空，做比较
        for (let i = 0; i < newData.length; i++) {
          let newItem = newData[i],
            newItemArr = [],
            localData = this.localParticularData;

          newItemArr.push(newItem.firstValue || "");
          newItemArr.push(newItem.secondValue || "");
          newItemArr.push(newItem.thirdValue || "");

          for (let j = 0; j < localData.length; j++) {
            let localItem = localData[j],
              localItemArr = [];

            localItemArr.push(localItem.firstValue || "");
            localItemArr.push(localItem.secondValue || "");
            localItemArr.push(localItem.thirdValue || "");

            let newItemArrSort = newItemArr.sort(),
              localItemArrSort = localItemArr.sort();
            if (
              newItemArrSort[0] == localItemArrSort[0] &&
              newItemArrSort[1] == localItemArrSort[1] &&
              newItemArrSort[2] == localItemArrSort[2]
            ) {
              // 新规格 已经存在，不需要更新
              // 判断新规格是否为空，是的话用本地缓存数据更新
              if (
                !newItem.price &&
                !newItem.stock &&
                !newItem.weight &&
                !newItem.skuCode &&
                !newItem.cost &&
                !newItem.presetSale
              ) {
                newItem.price = localItem.price;
                newItem.stock = localItem.stock;
                newItem.weight = localItem.weight;
                newItem.skuCode = localItem.skuCode;
                newItem.cost = localItem.cost;
                newItem.presetSale = localItem.presetSale;
              } else {
                localItem.price = newItem.price;
                localItem.stock = newItem.stock;
                localItem.weight = newItem.weight;
                localItem.skuCode = newItem.skuCode;
                localItem.cost = newItem.cost;
                localItem.presetSale = newItem.presetSale;
              }
              break;
            } else {
              // 新规格 不存在，插入本地缓存
              if (j == localData.length - 1) {
                this.localParticularData.push(newItem);
              }
            }
          }
        }
      }
    },
    // 合并规格明细表格中相同的规格名
    handleParticularTableRowMethod: function ({
      row,
      column,
      rowIndex,
      columnIndex,
    }) {
      let specificationList = this.formData.baseInfo.specification.list,
        particularData = [],
        firstLen = this.handleGetSpecificationValuesLenthMethod(0) || 1,
        secondLen = this.handleGetSpecificationValuesLenthMethod(1) || 1,
        thirdLen = this.handleGetSpecificationValuesLenthMethod(2) || 1;

      if (
        specificationList[0] &&
        specificationList[0].valueNameList.length > 0 &&
        columnIndex === 0
      ) {
        if (rowIndex % (secondLen * thirdLen) === 0) {
          return {
            rowspan: secondLen * thirdLen,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }

      if (
        specificationList[1] &&
        specificationList[1].valueNameList.length > 0 &&
        columnIndex === 1
      ) {
        if (rowIndex % thirdLen === 0) {
          return {
            rowspan: thirdLen,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    // 获取各个规格名下规格值不为空的规格值长度
    handleGetSpecificationValuesLenthMethod: function (index) {
      let specificationList = this.formData.baseInfo.specification.list,
        item = specificationList[index],
        len = 0;

      if (item && item.valueNameList.length > 0) {
        for (let i = 0; i < item.valueNameList.length; i++) {
          if (item.valueNameList[i].name) {
            len += 1;
          }
        }
      }

      return len;
    },
    // 规格明细 - 批量设置 - 价格
    handleParticularSetPrice: function () {
      this.particularTools.price = "";
      this.particularTools.priceInputShow = true;
    },
    // 规格明细 - 批量设置 - 价格 - 保存
    handleParticularSetPriceSubmit: function () {
      let particularData = this.formData.baseInfo.specification.particularData;

      for (let i = 0; i < particularData.length; i++) {
        particularData[i].price = this.particularTools.price;
      }

      this.particularTools.priceInputShow = false;
      this.handleSetBaseInfoPrice();
    },
    // 规格明细 - 批量设置 - 价格 - 取消
    handleParticularSetPriceCancel: function () {
      this.particularTools.priceInputShow = false;
    },
    // 规格明细 - 批量设置 - 库存
    handleParticularSetStock: function () {
      this.particularTools.stock = "";
      this.particularTools.stockInputShow = true;
    },
    // 规格明细 - 批量设置 - 库存 - 保存
    handleParticularSetStockSubmit: function () {
      let particularData = this.formData.baseInfo.specification.particularData;

      for (let i = 0; i < particularData.length; i++) {
        particularData[i].stock = this.particularTools.stock;
      }

      this.particularTools.stockInputShow = false;
      this.handleSetBaseInfoStock();
    },
    // 规格明细 - 批量设置 - 库存 - 取消
    handleParticularSetStockCancel: function () {
      this.particularTools.stockInputShow = false;
    },
    // 物流信息 - 批量设置 - 重量
    handleParticularSetWeight: function () {
      this.particularTools.weight = "";
      this.particularTools.weightInputShow = true;
    },
    // 物流信息 - 批量设置 - 重量 - 保存
    handleParticularSetWeightSubmit: function () {
      let particularData = this.formData.baseInfo.specification.particularData;

      for (let i = 0; i < particularData.length; i++) {
        particularData[i].weight = this.particularTools.weight;
      }

      this.particularTools.weightInputShow = false;
      this.updateLocalParticularData();
    },
    // 物流信息 - 批量设置 - 重量 - 取消
    handleParticularSetWeightCancel: function () {
      this.particularTools.weightInputShow = false;
    },
    //  规格排序弹窗 - 显示
    handleSpecificationDialogShow: function () {
      this.sorting = false;
      this.formData.baseInfo.specification.listClone = JSON.parse(
        JSON.stringify(this.formData.baseInfo.specification.list),
      );
      this.specificationSortDialogShow = true;
    },
    //  规格排序弹窗 - 隐藏
    handleSpecificationDialogHide: function () {
      this.specificationSortDialogShow = false;
    },
    //  规格排序弹窗 - 确定
    handleSpecificationDialogSubmit: function () {
      this.sorting = true;
      this.specificationSortDialogShow = false;
    },
    // 规格排序弹窗 - 完全打开后触发的事件
    handleSpecificationDialogOpened: function () {
      let listClone = this.formData.baseInfo.specification.listClone;

      if (listClone.length > 0) {
        for (let i = 0; i < listClone.length; i++) {
          let sortArr = document.getElementsByClassName("sort-item-" + i);

          if (sortArr.length > 0) {
            for (let j = 0; j < sortArr.length; j++) {
              let item = sortArr[j];

              item.draggable = true;
              item.style.cursor = "all-scroll";

              item.removeEventListener("dragstart", this.handleSortDragStart);
              item.addEventListener(
                "dragstart",
                this.handleSortDragStart,
                false,
              );

              item.removeEventListener("dragover", this.handleSortDragover);
              item.addEventListener("dragover", this.handleSortDragover, false);

              item.removeEventListener("drop", this.handleSortDrop);
              item.addEventListener("drop", this.handleSortDrop, false);
            }
          }
        }
      }
    },
    handleSortDragStart: function (ev) {
      ev.dataTransfer.setData("nindex", ev.target.dataset.nindex);
      ev.dataTransfer.setData("vindex", ev.target.dataset.vindex);
    },
    handleSortDragover: function (ev) {
      ev.preventDefault();
    },
    handleSortDrop: function (ev) {
      ev.preventDefault();

      let originalNindex = ev.dataTransfer.getData("nindex"),
        originalVindex = ev.dataTransfer.getData("vindex"),
        targetNindex = ev.target.getAttribute("data-nindex"),
        targetVindex = ev.target.getAttribute("data-vindex");

      if (originalNindex != targetNindex) {
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.formData.baseInfo.specification.listClone[
        targetNindex
      ].valueNameList.splice(originalVindex, 1);
      this.formData.baseInfo.specification.listClone[
        targetNindex
      ].valueNameList.splice(targetVindex, 0, originalObject[0]);
    },
    // 规格排序弹窗 - 隐藏时触发的事件
    handleSpecificationDialogClose: function () {
      if (this.sorting) {
        let listClone = this.formData.baseInfo.specification.listClone;

        this.formData.baseInfo.specification.list = JSON.parse(
          JSON.stringify(listClone),
        );

        this.handlePackageSpecificationToParticular();
      }
    },
    // 根据规格明细表内价格变化，设置基础信息价格，取所有规格中价格最低的
    handleSetBaseInfoPrice: function () {
      this.updateLocalParticularData();

      let particularData = this.formData.baseInfo.specification.particularData,
        priceArr = [];

      for (let i = 0; i < particularData.length; i++) {
        if (particularData[i].price) {
          priceArr.push(particularData[i].price);
        }
      }

      if (priceArr.length == 0) {
        return false;
      }

      priceArr.sort(function (a, b) {
        return a - b;
      });

      const { latestRate, unit } = this;
      if (unit == 1) {
        // 韩元
        this.formData.baseInfo.koreaPrice = priceArr[0];
        this.formData.baseInfo.price = (priceArr[0] * latestRate).toFixed(2);
      } else {
        // 人民币
        this.formData.baseInfo.price = priceArr[0];
        this.formData.baseInfo.koreaPrice = Math.ceil(priceArr[0] / latestRate);
      }
    },
    handlePriceChange: function () {},
    // 人民币兑韩元汇率变化
    handleCnyToKrwRateChange: function () {
      // 如果输入为空，不设置默认值，直接返回
      if (
        this.cnyToKrwRate === "" ||
        this.cnyToKrwRate === null ||
        this.cnyToKrwRate === undefined
      ) {
        return;
      }

      let cnyToKrwRate = parseFloat(this.cnyToKrwRate);
      if (cnyToKrwRate <= 0 || isNaN(cnyToKrwRate)) {
        // 如果输入值无效，保持原值不变，不进行转换
        return;
      }

      // 保留两位小数
      cnyToKrwRate = parseFloat(cnyToKrwRate.toFixed(2));
      this.cnyToKrwRate = cnyToKrwRate;

      // 将人民币兑韩元汇率转换为韩元兑人民币汇率
      // cnyToKrwRate: 1人民币 = cnyToKrwRate韩元
      // latestRate: 1韩元 = latestRate人民币
      // 所以 latestRate = 1 / cnyToKrwRate
      this.latestRate = 1 / cnyToKrwRate;

      // 触发价格转换
      this.handleRateChange();
    },
    // 汇率变化（韩元兑人民币）
    handleRateChange: function () {
      const { latestRate, latestRateOrigin } = this;
      if (latestRate <= 0 || !latestRate) {
        this.latestRate = latestRateOrigin;
        // 同步更新显示的人民币兑韩元汇率
        this.cnyToKrwRate =
          latestRateOrigin > 0
            ? parseFloat((1 / latestRateOrigin).toFixed(2))
            : 1.0;
      } else {
        // 同步更新显示的人民币兑韩元汇率
        this.cnyToKrwRate = parseFloat((1 / latestRate).toFixed(2));
      }

      const { unit } = this;
      const { price, koreaPrice } = this.formData.baseInfo;
      if (unit == 1) {
        // 韩元
        this.formData.baseInfo.price = (koreaPrice * this.latestRate).toFixed(
          2,
        );
      } else {
        // 人民币
        this.formData.baseInfo.koreaPrice = Math.ceil(price / this.latestRate);
      }
    },
    // 价格单位切换
    handlePriceUnitSwitch() {
      const { latestRate, formData, unit } = this;
      const { price, koreaPrice } = formData.baseInfo;
      const { particularData } = formData.baseInfo.specification;
      if (unit == 1) {
        // 韩元
        formData.baseInfo.koreaPrice = Math.ceil(price / latestRate);
        particularData.map((row) => {
          row.price = Math.ceil(row.price / latestRate);
        });
      } else {
        // 人民币
        formData.baseInfo.price = (koreaPrice * latestRate).toFixed(2);
        particularData.map((row) => {
          row.price = (row.price * latestRate).toFixed(2);
        });
      }
      this.formData.baseInfo.specification.particularData = particularData;
    },
    // 根据规格明细表内价格变化，设置基础信息库存，取所有规格中的库存总和
    handleSetBaseInfoStock: function () {
      this.updateLocalParticularData();

      let particularData = this.formData.baseInfo.specification.particularData,
        stock = 0;

      for (let i = 0; i < particularData.length; i++) {
        if (particularData[i].stock) {
          stock += parseInt(particularData[i].stock);
        }
      }

      this.formData.baseInfo.stock = stock;
    },
    // 根据规格明细表内预设销量的变化，设置基础信息预设销量，取所有规格中的预设销量总和
    handleSetBaseInfoPresetSale: function () {
      this.updateLocalParticularData();

      let particularData = this.formData.baseInfo.specification.particularData,
        presetSale = 0;

      for (let i = 0; i < particularData.length; i++) {
        if (particularData[i].presetSale) {
          presetSale += parseInt(particularData[i].presetSale);
        }
      }

      this.formData.baseInfo.presetSale = presetSale;
    },
    // 物流信息 - 快递发货 - 发货方式 改变
    handleDeliverFeeTypeChange: function (val) {
      // if(val == '0') {
      //     this.formData.deliverInfo.shippingTemplatesId = '';
      // } else if(val == '1') {
      //     this.formData.deliverInfo.deliverFee = '';
      // }
    },
    // 获取运费模版列表
    handleGetCommodityShippingTemplateList: function (callback) {
      this.shippingTemplatesOptionsLoading = true;

      let params = {
        pageNo: 1,
        pageSize: 1000,
      };

      commodityShippingTemplateList(params).then((res) => {
        this.shippingTemplatesOptionsLoading = false;

        let { code, data, msg } = res;

        if (code == 0) {
          let dataArray = data.records || [];

          if (dataArray.length == 0) {
            this.shippingTemplatesOptions = [];
          } else {
            this.shippingTemplatesOptions = [];
            for (let i = 0; i < dataArray.length; i++) {
              let item = dataArray[i],
                name = "";

              if (item.type == 1) {
                name = "按件";
              } else if (item.type == 2) {
                name = "按重";
              }

              this.shippingTemplatesOptions.push({
                id: "" + item.id,
                type: item.type,
                name: name + ": " + item.name,
              });

              if (typeof callback === "function") {
                callback();
              }
            }
          }
        }
      });
    },
    // 检测运费模版变化
    handleDeliverWeightTypeChange: function (val) {
      if (!val) {
        this.formData.deliverInfo.showWeight = false;
        return false;
      }

      let type = "";

      if (this.shippingTemplatesOptions.length == 0) {
        type = this.handleGetCommodityShippingTemplateList(
          this.handleGetShippingTemplateType(val),
        );
      } else {
        type = this.handleGetShippingTemplateType(val);
      }

      this.formData.deliverInfo.showWeight = type == 2 ? true : false;
    },
    // 根据模版id获取模版类型值
    handleGetShippingTemplateType: function (id) {
      for (let i = 0; i < this.shippingTemplatesOptions.length; i++) {
        let item = this.shippingTemplatesOptions[i];

        if (item.id == id) {
          return item.type;
          break;
        }
      }
    },
    // 统一重量值变化
    handleSameWeightChange: function () {
      let weight = this.formData.deliverInfo.weight,
        particularData = this.formData.baseInfo.specification.particularData;

      for (let i = 0; i < particularData.length; i++) {
        particularData[i].weight = weight;
      }

      this.formData.baseInfo.specification.particularData = particularData;
      this.updateLocalParticularData();
    },
    // 视频上传之前
    handleVideosBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split("."),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ["mp4", "mov"];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error("请上传MP4、MOV格式的图片");
        return false;
      }
    },
    handleVideosSuccess: function (response, file, fileList) {
      this.uploadVideoList = fileList;
    },
    handleVideosError: function (err, file, fileList) {
      this.$message.error("视频上传失败");
      this.uploadVideoList = fileList;
    },
    handleVideosExceed: function (files, fileList) {
      this.$message.error("视频最多上传" + this.videosLimit + "个");
    },
    handleVideosRemove: function (file, fileList) {
      this.uploadVideoList = [];
    },
    handleVideosPreview: function (file) {
      this.previewVideoDialogUrl = this.uploadVideoList[0].response.data.path;
      this.previewVideoDialogShow = true;
    },
    // 图片上传之前
    handlePicturesBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split("."),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ["jpg", "jpeg", "png"];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error("请上传jpg、jpeg、png格式的图片");
        return false;
      }
    },
    //  图片上传成功
    handlePicturesSuccess: function (response, file, fileList) {
      this.uploadPicList = fileList;
      console.log(this.uploadPicList, "*-*-uploadPicList2");
    },
    // 图片上传失败
    handlePicturesError: function (err, file, fileList) {
      this.$message.error("图片上传失败");
      this.uploadPicList = fileList;
    },
    // 图片数量超出限制
    handlePicturesExceed: function (files, fileList) {
      this.$message.error("图片最多上传" + this.picsLimit + "张");
    },
    // 图片删除
    handlePicturesRemove: function (file, fileList) {
      this.uploadPicList = fileList;
    },
    // 图片预览
    handlePicturesPreview: function (file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },
    // 图片列表排序
    handlePicListSort: function () {
      let picLI = document
        .getElementsByClassName("pics-box-goods")[0]
        .getElementsByClassName("el-upload-list")[0]
        .getElementsByTagName("li");

      for (let i = 0; i < picLI.length; i++) {
        let picLIItem = picLI[i];

        picLIItem.draggable = true;
        picLIItem.setAttribute("data-index", i);
        picLIItem.style.cursor = "all-scroll";

        picLIItem.removeEventListener("dragstart", this.handlePicLIDragStart);
        picLIItem.addEventListener(
          "dragstart",
          this.handlePicLIDragStart,
          false,
        );

        picLIItem.removeEventListener("dragover", this.handlePicLIDragover);
        picLIItem.addEventListener("dragover", this.handlePicLIDragover, false);

        picLIItem.removeEventListener("drop", this.handlePicLIDrop);
        picLIItem.addEventListener("drop", this.handlePicLIDrop, false);
      }
    },
    // 拖动开始
    handlePicLIDragStart: function (ev) {
      ev.dataTransfer.setData("index", ev.target.dataset.index);
    },
    // 必须存在，否则不会触发drop事件
    handlePicLIDragover: function (ev) {
      ev.preventDefault();
    },
    //  拖动结束
    handlePicLIDrop: function (ev) {
      ev.preventDefault();

      let originalIndex = ev.dataTransfer.getData("index"),
        liNode = this.handleGetLINode(ev.target),
        targetIndex = liNode.getAttribute("data-index");

      if (originalIndex == targetIndex) {
        // 原地释放
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.uploadPicList.splice(originalIndex, 1);
      this.uploadPicList.splice(targetIndex, 0, originalObject[0]);

      this.formData.baseInfo.pics = [];
      for (let i = 0; i < this.uploadPicList.length; i++) {
        // this.formData.baseInfo.pics.push(this.uploadPicList[i].response.data.url);
        this.formData.baseInfo.pics.push(
          this.uploadPicList[i].response.data.path,
        );
      }
    },
    // 循环获取目标dom的标签名，直到找到li，返回该li对象
    handleGetLINode: function (ob) {
      if (ob.tagName == "LI") {
        return ob;
      } else {
        return this.handleGetLINode(ob.parentNode);
      }
    },
    // 图片上传之前
    handleSpecificationPicturesBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split("."),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ["jpg", "jpeg", "png"];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error("请上传jpg、jpeg、png格式的图片");
        return false;
      }
    },
    handleSpecificationPicturesSuccess: function (response, file, fileList) {
      this.formData.baseInfo.specification.list[0].valueNameList[
        file.response.data.index
      ].picList = fileList;
    },
    handleSpecificationPicturesError: function (err, file, fileList) {
      this.$message.error("图片上传失败");
      // this.uploadPicList = fileList;
    },
    handleSpecificationPicturesExceed: function (files, fileList) {
      this.$message.error("图片最多上传" + this.specificationPicsLimit + "张");
    },
    handleSpecificationPicturesRemove: function (file, fileList) {
      this.formData.baseInfo.specification.list[0].valueNameList[
        file.response.data.index
      ].picList = fileList;
    },
    handleSpecificationPicturesPreview: function (file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },
    // 图片上传之前
    handleDetailPicturesBeforeUpload: function (file) {
      let fileName = file.name,
        fileNameArr = fileName.split("."),
        fileType = fileNameArr[fileNameArr.length - 1],
        supportArr = ["jpg", "jpeg", "png"];

      if (supportArr.indexOf(fileType) == -1) {
        this.$message.error("请上传jpg、jpeg、png格式的图片");
        return false;
      }
    },
    handleDetailPicturesSuccess: function (response, file, fileList) {
      this.detailUploadPicList = fileList;
    },
    handleDetailPicturesError: function (err, file, fileList) {
      this.$message.error("图片上传失败");
      // this.detailUploadPicList = fileList;
    },
    handleDetailPicturesRemove: function (file, fileList) {
      this.detailUploadPicList = fileList;
    },
    handleDetailPicturesPreview: function (file) {
      this.previewDialogImageUrl = file.url;
      this.previewDialogShow = true;
    },

    //  详情图片列表排序
    handleDetailPicListSort: function () {
      let picLI = document
        .getElementsByClassName("pics-box-detail")[0]
        .getElementsByClassName("el-upload-list")[0]
        .getElementsByTagName("li");

      for (let i = 0; i < picLI.length; i++) {
        let picLIItem = picLI[i];

        picLIItem.draggable = true;
        picLIItem.setAttribute("data-index", i);
        picLIItem.style.cursor = "all-scroll";

        picLIItem.removeEventListener(
          "dragstart",
          this.handleDetailPicLIDragStart,
        );
        picLIItem.addEventListener(
          "dragstart",
          this.handleDetailPicLIDragStart,
          false,
        );

        picLIItem.removeEventListener(
          "dragover",
          this.handleDetailPicLIDragover,
        );
        picLIItem.addEventListener(
          "dragover",
          this.handleDetailPicLIDragover,
          false,
        );

        picLIItem.removeEventListener("drop", this.handleDetailPicLIDrop);
        picLIItem.addEventListener("drop", this.handleDetailPicLIDrop, false);
      }
    },
    // 拖动开始
    handleDetailPicLIDragStart: function (ev) {
      ev.dataTransfer.setData("index", ev.target.dataset.index);
    },
    // 必须存在，否则不会触发drop事件
    handleDetailPicLIDragover: function (ev) {
      ev.preventDefault();
    },
    // 拖动结束
    handleDetailPicLIDrop: function (ev) {
      ev.preventDefault();

      let originalIndex = ev.dataTransfer.getData("index"),
        liNode = this.handleGetLINode(ev.target),
        targetIndex = liNode.getAttribute("data-index");

      if (originalIndex == targetIndex) {
        // 原地释放
        return false;
      }

      // 将移动的对象插入目标对象之前
      let originalObject = this.detailUploadPicList.splice(originalIndex, 1);
      this.detailUploadPicList.splice(targetIndex, 0, originalObject[0]);

      this.detailPics = [];
      for (let i = 0; i < this.detailUploadPicList.length; i++) {
        // this.detailPics.push(this.detailUploadPicList[i].response.data.url);
        this.detailPics.push(this.detailUploadPicList[i].response.data.path);
      }
    },
    // 循环获取目标dom的标签名，直到找到li，返回该li对象
    handleDetailGetLINode: function (ob) {
      if (ob.tagName == "LI") {
        return ob;
      } else {
        return this.handleGetLINode(ob.parentNode);
      }
    },
    // 改变当前步骤
    handleChangeStep: function (step) {
      if (this.step == step) {
        return false;
      }

      if (step == 2) {
        if (this.handleValidateForm()) {
          this.step = step;
        }
      } else if (step == 1) {
        this.step = step;
      }
    },
    //  保存数据
    handleFormSubmit: function (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 详情
          if (this.detailPics.length == 0) {
            this.$message.error("请上传商品详情图");
            return false;
          }
          let formData = this.formData,
            baseInfo = formData.baseInfo;
          // 类目
          let categoryArr = [];
          for (let i = 0; i < baseInfo.categoryList.length; i++) {
            let item = baseInfo.categoryList[i];

            categoryArr.push({
              firstCategoryId: item.firstCategoryId,
              secondCategoryId: item.secondCategoryId,
              // categoryLabelId: item.categoryLabelId || null
              categoryLabelId: null,
            });
          }
          // 规格
          let specificationListArr = [];
          for (let i = 0; i < baseInfo.specification.list.length; i++) {
            let item = baseInfo.specification.list[i],
              valueArr = [];

            for (let j = 0; j < item.valueNameList.length; j++) {
              let valueItem = item.valueNameList[j],
                url = "";

              if (
                this.specificationPicsUploadVisible &&
                valueItem.picList &&
                valueItem.picList[0]
              ) {
                // url = valueItem.picList[0].response.data.url;
                url = valueItem.picList[0].response.data.path;
              }

              valueArr.push({
                name: valueItem.name,
                url: url,
              });
            }

            specificationListArr.push({
              name: item.name,
              valueNameList: valueArr,
            });
          }
          // 标签
          let tagsArr = [];
          if (baseInfo.tags.length > 0) {
            for (let i = 0; i < baseInfo.tags.length; i++) {
              let item = baseInfo.tags[i];

              if (item.label) {
                tagsArr.push(item.label);
              }
            }
          }
          this.submitLoading = true;
          let params = {
            id: this.id || null,
            regionId: baseInfo.regionId, // 产地
            rateId: baseInfo.rateId, // 税率
            includeTax: baseInfo.includeTax, //
            warehouseId: baseInfo.warehouseId, // 仓库
            name: baseInfo.name, // 商品名称
            code: baseInfo.code || new Date().getTime(), // 商品编码
            type: baseInfo.type, // 商品类型
            abroadType: baseInfo.abroadType, // 商品仓库类型
            commodityType: baseInfo.commodityType, // 是否专链商品
            syncSys: baseInfo.abroadType, // 商品仓库类型
            sort: baseInfo.sort, // 排序号
            categoryInfo: JSON.stringify(categoryArr), // 类目
            sellingPoint: baseInfo.sellingPoint, // 卖点
            mainVideo: this.uploadVideoList[0]
              ? this.uploadVideoList[0].response.data.path
              : "",
            listPics: baseInfo.pics.join(","), // 商品图
            label: tagsArr.join(",") || null, // 标签
            customRate: this.latestRate,
            specificationJsonStr: JSON.stringify(specificationListArr), // 商品规格
            specificationDetailJsonStr: JSON.stringify(
              baseInfo.specification.particularData,
            ), // 商品规格明细
            unit: this.unit,
            stock: baseInfo.stock, // 库存
            presetSale: baseInfo.presetSale || null, // 预设销量
            deliverInfo: JSON.stringify({
              // 物流信息
              deliverType: formData.deliverInfo.deliverType, // 配送方式
              feeType: "0", // 收费类型
              deliverFee: 0, // 运费
              weightType: formData.deliverInfo.weightType, // 物流重量
              shippingTemplatesId: formData.deliverInfo.shippingTemplatesId, // 运费模板
            }), // 物流信息设置
            detailPics: this.detailPics.join(","),
            isJoinGoods: "0",
          };
          // 人民币
          params.price = baseInfo.price || "";
          params.nickPrice = baseInfo.nickPrice || "";
          // 韩币
          params.koreaPrice = baseInfo.koreaPrice || "";
          params.koreaNickPrice = baseInfo.koreaNickPrice || "";
          commoditySave(params)
            .then((res) => {
              this.submitLoading = false;

              let { code, data, msg } = res;

              if (code == 0) {
                this.$message({ message: "保存商品成功", type: "success" });

                this.$router.push({ path: "/goods/manage/list" });
              } else {
                this.$message.error(msg);
              }
            })
            .catch((error) => {
              this.submitLoading = false;
              this.$message.error("服务器异常");
            });
        } else {
          return false;
        }
      });
    },
    // 表单校验
    handleValidateForm: function () {
      let baseInfo = this.formData.baseInfo;
      // 产地
      if (!baseInfo.regionId) {
        this.$message.error("请选择产地");
        return false;
      }
      // 进口税税率
      if (!baseInfo.rateId) {
        this.$message.error("请选择进口税税率");
        return false;
      }
      // 发货仓库
      if (!baseInfo.warehouseId) {
        this.$message.error("请选择发货仓库");
        return false;
      }

      // 商品编码
      if (!baseInfo.code) {
        this.$message.error("请输入商品货号");
        return false;
      }

      // 商品名
      if (!baseInfo.name) {
        this.$message.error("请输入商品名称");
        return false;
      }

      // 商品类目
      let categoryList = baseInfo.categoryList;
      if (categoryList.length == 0) {
        this.$message.error("请添加分类");
        return false;
      }
      for (let i = 0; i < categoryList.length; i++) {
        let item = categoryList[i];

        if (!item.firstCategoryId || !item.secondCategoryId) {
          this.$message.error("请选择分类");
          return false;
        }
      }

      // 商品主图视频
      // if(baseInfo.pics.length == 0) {
      //     this.$message.error('请上传商品图');
      //     return false;
      // }

      // 商品图
      if (baseInfo.pics.length == 0) {
        this.$message.error("请上传商品图");
        return false;
      }

      // 标签
      if (baseInfo.tags.length > 0) {
        for (let i = 0; i < baseInfo.tags.length; i++) {
          let item = baseInfo.tags[i];

          if (item.label && item.label.length < 2) {
            this.$message.error("标签名长度需2-8个中文字符");
            return false;
          }
        }
      }

      // 规格
      let specification = baseInfo.specification.list;
      if (specification.length == 0) {
        this.$message.error("请添加商品规格");
        return false;
      } else {
        for (let i = 0; i < specification.length; i++) {
          let specificationItem = specification[i];

          if (!specificationItem.id) {
            this.$message.error("请选择商品规格名");
            return false;
          }

          if (specificationItem.valueNameList.length == 0) {
            this.$message.error("请添加商品规格值");
            return false;
          }

          for (let j = 0; j < specificationItem.valueNameList.length; j++) {
            let valueItem = specificationItem.valueNameList[j];

            if (!valueItem.name) {
              this.$message.error("请选择商品规格值");
              return false;
            }
          }
        }
      }

      // 规格明细
      let particularData = baseInfo.specification.particularData,
        skuCodeArr = [];
      for (let i = 0; i < particularData.length; i++) {
        let particularDataItem = particularData[i];

        if (particularDataItem.price === "") {
          this.$message.error("请输入规格明细的价格");
          return false;
        }

        if (particularDataItem.stock === "") {
          this.$message.error("请输入规格明细的库存");
          return false;
        }

        if (particularDataItem.skuCode === "") {
          this.$message.error("请输入规格明细的规格编码");
          return false;
        }

        if (skuCodeArr.indexOf(particularDataItem.skuCode) > -1) {
          this.$message.error(
            "规格编码[" + particularDataItem.skuCode + "]不能重复",
          );
          return false;
        } else {
          skuCodeArr.push(particularDataItem.skuCode);
        }
      }

      // 价格
      if (baseInfo.price === "") {
        this.$message.error("请输入价格");
        return false;
      }

      // 库存
      if (baseInfo.stock === "") {
        this.$message.error("请输入库存");
        return false;
      }

      // if(baseInfo.type == '0') {
      //     // 物流信息
      //     let deliverInfo = this.formData.deliverInfo;

      //     if(!deliverInfo.feeType) {
      //         this.$message.error('请选择快递运费');
      //         return false;
      //     }
      //     if(deliverInfo.feeType == '0' && deliverInfo.deliverFee === '') {
      //         this.$message.error('请填写统一邮费');
      //         return false;
      //     }
      //     if(deliverInfo.feeType == '1' && !deliverInfo.shippingTemplatesId) {
      //         this.$message.error('请选择运费模版');
      //         return false;
      //     }

      //     if(deliverInfo.feeType == '1' && deliverInfo.showWeight && !deliverInfo.weight && deliverInfo.weightType == '0') {
      //         this.$message.error('请输入统一重量');
      //         return false;
      //     }
      //     if(deliverInfo.feeType == '1' && deliverInfo.weightType == '1') {
      //         let particularData = baseInfo.specification.particularData;

      //         for(let i = 0; i < particularData.length; i++) {
      //             let particularDataItem = particularData[i];

      //             if(!particularDataItem.weight) {
      //                 this.$message.error('请完善物流重量');
      //                 return false;
      //             }
      //         }
      //     }
      // }

      return true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../common/styles/base/mixin-font";
@import "../../../common/styles/base/mixin-common";

.steps-bar {
  border-radius: 48px;
  overflow: hidden;
  background: $colorTitleBg;

  .steps-item {
    background: transparent;
    font-size: $baseFS;
    line-height: 48px;
    text-align: center;

    &.active {
      background: $themeColor;
      color: $colorWhite;
      border-radius: 48px;
    }
  }
}

.select-type {
  display: flex;
  align-items: center;

  .link {
    .type-item {
      margin-left: 30px !important;

      & + .type-item {
        margin-left: 10px !important;
      }
    }
  }
}

.type-wrap {
  font-size: 0;
  text-align: left;

  .type-item {
    position: relative;
    display: inline-block;
    margin-left: 80px;
    padding: 10px 20px;
    border: 1px solid #dddddd;
    border-radius: 2px;
    cursor: pointer;

    & + .type-item {
      margin-left: 10px;
    }

    .label {
      font-size: 12px;
      line-height: 17px;
      color: #222;
      text-align: center;
    }

    .tips {
      margin-top: 4px;
      font-size: 12px;
      line-height: 17px;
      color: rgba(#222, 0.5);
      text-align: center;
    }

    &.active {
      border-color: $themeColor;

      .label {
        color: $themeColor;
      }

      &::before {
        content: "";
        @include position(absolute, 3, 0, 0, none, none);
        width: 16px;
        height: 16px;
        @include backgroundImage(
          "../../../assets/icon_16_2@2x.png",
          no-repeat,
          right,
          center,
          auto,
          16px
        );
      }
    }
  }
}

.radio-block {
  .tips {
    margin-left: 24px;
  }
}

.checkbox-block,
.switch-block {
  & + .checkbox-block,
  & + .switch-block {
    margin-left: 20px;
  }
}

.grey-inline-block {
  display: inline-block;
  background: $colorPageBg;
}

.paticular-table {
  background-color: transparent;

  &::before {
    display: none;
  }

  .el-table__header-wrapper {
  }

  ::v-deep .el-table__body-wrapper {
    .el-table__body {
      .el-table__row {
        background-color: transparent;

        td {
          padding: 5px 0;
          border-bottom-color: #ebeef5;
          /*border-bottom-color: transparent;*/
        }
      }
    }
  }
}

.pics-box {
  ::v-deep .el-upload-list--picture-card {
    .el-upload-list__item {
      position: relative;
      width: 100px;
      height: 100px;
      border-radius: 2px;
      transition: none;

      .el-upload-list__item-thumbnail {
        @include position(absolute, none, 50%, none, none, 50%);
        @include translate(-50%, -50%, 0);
      }

      .el-progress {
        width: 80px;
        height: 80px;

        .el-progress-circle {
          width: 80px !important;
          height: 80px !important;
        }
      }

      .el-icon-close-tip {
        display: none;
      }

      .el-upload-list__item-actions {
        cursor: move;
      }
    }
  }

  ::v-deep .el-upload--picture-card {
    width: 100px;
    height: 100px;
    line-height: 98px;
    border-radius: 2px;

    .el-upload-dragger {
      width: 98px;
      height: 98px;
      border: none;

      .el-icon-plus {
        font-size: $baseFS;
      }
    }
  }

  .video-box {
    .video-item {
      position: relative;
      width: 100px;
      height: 100px;

      .video {
        width: 98px;
        height: 98px;
        border: 1px solid #c0ccda;
      }

      .mask {
        @include position(absolute, 1, 0, 0, 0, 0);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background: rgba(#000, 0.5);
        opacity: 0;
        transition: opacity 0.3s;

        i {
          font-size: 20px;
          color: #fff;
          cursor: pointer;

          & + i {
            margin-left: 15px;
          }
        }
      }

      &:hover {
        .mask {
          opacity: 1;
          transition: opacity 0.3s;
        }
      }
    }
  }
}

.particular-toolbar {
  padding: 8px 10px;
}

.sort-item {
  display: inline-block;
  padding: 0 12px;
  margin-right: 10px;
  line-height: 28px;
  white-space: nowrap;
  background-color: #eee;
  font-size: $smallFS;
  color: $textColor;
  border-radius: 2px;

  &:hover,
  &:focus {
    background-color: rgba(#5bcfe6, 0.2);
  }
}

.delete-block-category {
  margin-left: 70px;
  margin-bottom: 18px;

  .el-form-item {
    margin-left: -70px;
    margin-bottom: 0;

    & + .el-form-item {
      margin-top: 8px;
    }
  }
}

.specification-value-item {
  float: left;

  .specification-pics-box {
    position: relative;
    margin-bottom: 10px;

    .pics-box {
      width: 100px;
      height: 100px;
      overflow: hidden;
    }
  }
}

.select-loading {
  @include position(absolute, 10, 3px, 2px, 3px, 0);
  display: block;
  background: transparent;
  width: 100%;
  border: none;
  pointer-events: inherit;

  /*&::before{
            display: none;
        }*/

  &::after {
    border: none;
  }

  ::v-deep .el-icon-loading {
    color: $themeColor;
  }
}
</style>
